module.exports = __webpack_public_path__ + "static/media/Talk2Partners.daa8c2eb.png";